module.exports = __webpack_public_path__ + "media/images/icons/icon_search-04abee5903493584a184c16e82957be2.svg";